export default __webpack_public_path__ + "static/media/emsLogoV2.f3012fdc.png";